import React from "react";

export const moveFormatter = (cell, row, text) => {
  if (text) {
    return cell === true || cell === 1 ? "True" : "False";
  }
  if (cell === true || cell === 1 || cell === "true") {
    return <i className="text-green-500 fa fa-check"></i>;
  }
  // If the cell's value is false, return a cross icon
  else if (cell === false || cell === 0 || cell === "false") {
    return <i className="text-red-500 fa fa-times"></i>;
  }
  // Return null or an appropriate representation if the value is neither true nor false
  return null;
};
